import { render } from "./invoices_import.vue?vue&type=template&id=5906c61b&scoped=true"
import script from "./invoices_import.vue?vue&type=script&lang=js"
export * from "./invoices_import.vue?vue&type=script&lang=js"

import "./invoices_import.vue?vue&type=style&index=0&id=5906c61b&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5906c61b"]])

export default __exports__